module.exports = __webpack_public_path__ + "static/media/pcb111.0e4ece40.jpg";